import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { ConfigProvider } from "antd";
import { useSelector } from "react-redux";
import esES from "antd/locale/es_ES";

import LoginPage from "./routes/login/loginpage.component";
import Navigation from "./component/navigation/navigation.component";
import DashboardPage from "./routes/dashboard/dashboard.component";
import UserMaintenancePage from "./routes/user-maintenance/user-maintenance.component";
import ResidentMaintenancePage from "./routes/resident-maintenance/resident-maintenance.component";
import LocationMaintenancePage from "./routes/location-maintenance/location-maintenance.component";
import VisitsReportPage from "./routes/visits-report/visits-report.component";
import InvitationsReportPage from "./routes/invitations-report/invitations-report.component";
import GuestReportPage from "./routes/guest-report/guest-report.component";
import SchedulesMaintenancePage from "./routes/schedules-maintenance/schedules-maintenance.component";
import SchedulesGroupMaintenancePage from "./routes/schedules-group-maintenance/schedules-group-maintenance.component";
import PreAuthorizedMaintenancePage from "./routes/pre-authorized-maintenance/pre-authorized-maintenance.component";
import SettingsPage from "./routes/settings/settings.component";

import "./App.css";

function App() {
  const user = useSelector((state) => state.userAccount.user);

  return (
    <ConfigProvider
      theme={{ token: { colorPrimary: "#1a6db0" } }}
      locale={esES}
    >
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={
              <ProtectLogin>
                <LoginPage />
              </ProtectLogin>
            }
          />
          <Route
            path="/"
            element={
              <ProtectMain>
                <Navigation userName={user?.name} />
              </ProtectMain>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="user-maintenance" element={<UserMaintenancePage />} />
            <Route
              path="resident-maintenance"
              element={<ResidentMaintenancePage />}
            />
            <Route
              path="location-maintenance"
              element={<LocationMaintenancePage />}
            />
            <Route path="visits-report" element={<VisitsReportPage />} />
            <Route
              path="invitations-report"
              element={<InvitationsReportPage />}
            />
            <Route path="guest-report" element={<GuestReportPage />} />
            <Route
              path="schedules-maintenance"
              element={<SchedulesMaintenancePage />}
            />
            <Route
              path="schedules-group-maintenance"
              element={<SchedulesGroupMaintenancePage />}
            />
            <Route
              path="pre-authorized-maintenance"
              element={<PreAuthorizedMaintenancePage />}
            />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </div>
    </ConfigProvider>
  );
}

function ProtectLogin({ children }) {
  const user = useSelector((state) => state.userAccount.user);
  const location = useLocation();

  if (user != null) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}

function ProtectMain({ children }) {
  const user = useSelector((state) => state.userAccount.user);
  const location = useLocation();

  if (user == null) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default App;
